export let retryMessage = "x8iRDc";
export let notFoundMessage = "_MttJb";
export let retryActionButtonLabel = "OQP6h";
export let goHomeButtonLabel = "LXFjKb";
export default {retryMessage,notFoundMessage,retryActionButtonLabel,goHomeButtonLabel};